"use client";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "./ProgrameHighlight.css";
import Main_heading_holder from "../../common_components/common_css/main_heading_holder/Main_heading_holder";

const ProgrameHighlight = ({ spanHeadingColor = "#ad314d" }) => {
  
  // Static data
  const data = [
    {
      image: "/assets/images/dpu_mca/job_profile/Asset22.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset23.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset24.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset25.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset26.svg",
    },
       {
      image: "/assets/images/dpu_mca/job_profile/Asset27.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset28.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset29.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset30.svg",
    },
    {
      image: "/assets/images/dpu_mca/job_profile/Asset31.svg",
    },
      {
      image: "/assets/images/dpu_mca/job_profile/Asset32.svg",
    },
      {
      image: "/assets/images/dpu_mca/job_profile/Asset33.svg",
    },
  ];

  return (
    <>
      {data.length > 0 && (
        <section className="programe-highlight">

           {/* Heading */}
           <Main_heading_holder
              heading={" "}
              spanHeading={" Get yourself into the job profiles of"}
              spanHeadingColor={spanHeadingColor}
            />

          <Container>
            <Row className="mt-4">
                {data.map((item, index) => (
                  <Col lg={2} md={3} sm={4} xs={4} key={index}>
                    <div className="main-section mb-5">
                      
                      <img
                        src={item.image}
                        className="all-image"
                        alt={item.name}
                      />

                      <div className="text-holder">
                        <p>{item.name}</p>
                      </div>

                      {/* <div className="bg-overlay"></div> */}

                    </div>
                  </Col>
                ))}
            </Row>
          </Container>
        </section>
      )}
    </>
  );
};

export default ProgrameHighlight;